<a href="#UppyDashboard">
  <h2 id="UppyDashboard">Uppy Dashboard Demos</h2>
</a>

<br>
<br>
<h3>Uppy Dashboard Single File Select</h3>
<aero-button
  label="Uppy Dashboard"
  (onClick)="uppyDashboard1.open()"
></aero-button>
<bulb-uppy-dashboard
  #uppyDashboard1
  (uppyEventEmitter)="handleSuccessEvent($event)"
></bulb-uppy-dashboard>

<br>
<br>
<h3>Uppy Dashboard Multi File Select</h3>
<aero-button
  label="Uppy Dashboard"
  (onClick)="uppyDashboard2.open()"
></aero-button>
<bulb-uppy-dashboard
  #uppyDashboard2
  (uppyEventEmitter)="handleSuccessEvent($event)"
  [multiSelect]="true"
  ></bulb-uppy-dashboard>

<br>
<br>
<h3>Uppy Dashboard Only Image Select</h3>
<aero-button
  label="Uppy Dashboard"
  (onClick)="uppyDashboard3.open()"
></aero-button>
<bulb-uppy-dashboard
  #uppyDashboard3
  [allowedFileType]="allowedFileTypes"
  (uppyEventEmitter)="handleSuccessEvent($event)"
></bulb-uppy-dashboard>

<br>
<br>
<h3>Uppy Dashboard with Asset Library</h3>
<aero-button
  label="Uppy Dashboard"
  (onClick)="uppyDashboard4.open()"
></aero-button>
<bulb-uppy-dashboard
  #uppyDashboard4
  (uppyEventEmitter)="handleSuccessEvent($event)"
  [showAssetLibrary]="true"
></bulb-uppy-dashboard>
<br>
<br>

<p-toast key="uppyUploadToast"></p-toast>
